<template>
  <img class="checkbox"
    :src="iconUrlRef"
    role="checkbox"
    tabindex="0"
    @click="onClick"/>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import checkedUrl from '@/assets/icons/checkbox_checked.png'
import checkedDisabledUrl from '@/assets/icons/checkbox_checked_disabled.png'
import checkedReadOnlyUrl from '@/assets/icons/checkbox_checked_readonly.png'
import partialUrl from '@/assets/icons/checkbox_partial.png'
import uncheckedUrl from '@/assets/icons/checkbox_unchecked.png'
import uncheckedDisabledUrl from '@/assets/icons/checkbox_unchecked_disabled.png'
import uncheckedReadOnlyUrl from '@/assets/icons/checkbox_unchecked_readonly.png'

const props = defineProps<{
  checked?: boolean
  disabled?: boolean
  readonly?: boolean
}>()

const emit = defineEmits<{
  (e: 'update:checked', value: boolean): void
}>()

const iconUrlRef = computed(() => {
  if (props.disabled) {
    return props.checked ? checkedDisabledUrl : uncheckedDisabledUrl
  }
  if (props.readonly) {
    return props.checked ? checkedReadOnlyUrl : uncheckedReadOnlyUrl
  }
  if (props.checked == undefined) {
    return partialUrl
  }
  return props.checked ? checkedUrl : uncheckedUrl
})

function onClick() {
  if (!props.disabled && !props.readonly) {
    emit('update:checked', !props.checked)
  }
}
</script>
